<!-- =========================================================================================
  File Name: addSidebarView.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} SCHEDULE</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- NAME -->
        <vs-input label="Schedule Name" v-model="currrent_schedule.name" class="mt-5 w-full" name="item-name" v-validate="'required'" maxlength="100"/>
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span><br>
       <div class="slot-fields" v-for="(date, index) in currrent_schedule.dates" :key="index">
      <br>{{index}}
      <vs-button class="float-right" v-if="date.length==0" color="primary" size="small" @click.native="inputAdd(index)"> <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/> </vs-button>    
      <div class="slot-fields" v-for="(item, dayindex) in date" :key="dayindex">
     <small style="color:red">{{getTime(index,dayindex,item.start_time,item.end_time)}}</small>
    <vs-row>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
   <flat-pickr v-model="item.start_time" :config="configdateTimePicker" class="timepicker" name="start_time" placeholder="Start time"/>
   </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
    <flat-pickr v-model="item.end_time" :config="configdateTimePicker" class="timepicker" name="end_time" placeholder="End time"/>
    <!-- <span class="danger" @click="inputRemove(index,dayindex)" style="color:red">x</span> -->
   </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" >
      <vs-button color="danger" size="small" @click.native="inputRemove(index,dayindex)" > <feather-icon icon="MinusIcon" svgClasses="h-4 w-4"/> </vs-button>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" v-if="currrent_schedule.dates[index].length-1===dayindex">
      <vs-button color="primary" size="small" @click.native="inputAdd(index)"> <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/> </vs-button>
    </vs-col>
  </vs-row>
    </div>
  <vs-tooltip text="Copy to all days" position="left">
  <vs-button @click.native="copytoall()" class="p-1 mt-1" size="small" v-if="index==='Monday' && currrent_schedule.dates.Monday.length>0 && currrent_schedule.dates.Monday[0].start_time.length>0 && currrent_schedule.dates.Monday[0].end_time.length>0"><feather-icon icon="ArrowDownIcon" svgClasses="w-4 h-4" /> </vs-button>    
  </vs-tooltip>
    </div>
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import {CREATE_SCHEDULE, UPDATE_SCHEDULE} from '@/graphql'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    'v-select': vSelect,
    VuePerfectScrollbar,
    flatPickr,
    moduleDataList
  },
  data () {
    return {
      newcurrrent_schedule:  {
        dates: []
      },
      currrent_schedule:
        {
          'id': '',
          'name': '',
          'dates': {
            Monday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Tuesday: [
              {
                'start_time': '',
                'end_time': ''

              }
            ],
            Wednesday: [
              {
                'start_time': '',
                'end_time': ''

              }
            ],
            Thursday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Friday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Saturday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ],
            Sunday: [
              {
                'start_time': '',
                'end_time': ''
              }
            ]
          }
        },
      // currrent_schedule:
      //   {
      //     id:"",
      //     name: "",
      //     dates: [
      //         {
      //           "day":"",
      //           "start_time": "",
      //           "end_time": "",
      //         }
      //       ],
      //   },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: 'H:i',
        time_24hr: false,
        altInput: true,
        dateFormat: 'H:i'
      },
      deletedschedules:[],
      dataId: null,
      dataName: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, name, scheduledates} = JSON.parse(JSON.stringify(this.data))
        this.currrent_schedule.id = id
        this.currrent_schedule.name = name
        this.currrent_schedule.dates = {
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
          Saturday: [],
          Sunday: []
        }
        const getarry = []
        for (let i = 0; i < scheduledates.length; i++) {
        //  delete scheduledates[i].id
          delete scheduledates[i].__typename
          getarry.push(scheduledates[i])
        }
        for (let i = 0; i < getarry.length; i++) {
          const day = getarry[i].day
          if (day == 'Monday') {
            this.currrent_schedule.dates.Monday.push(getarry[i])
          }
          if (day == 'Tuesday') {
            this.currrent_schedule.dates.Tuesday.push(getarry[i])
          }
          if (day == 'Wednesday') {
            this.currrent_schedule.dates.Wednesday.push(getarry[i])
          }
          if (day == 'Thursday') {
            this.currrent_schedule.dates.Thursday.push(getarry[i])
          }
          if (day == 'Friday') {
            this.currrent_schedule.dates.Friday.push(getarry[i])
          }
          if (day == 'Saturday') {
            this.currrent_schedule.dates.Saturday.push(getarry[i])
          }
          if (day == 'Sunday') {
            this.currrent_schedule.dates.Sunday.push(getarry[i])
          }
        }
        this.initValues()
      }
    }
  },
  computed: {
    schedules () {
      return this.$store.state.dataList.schedules
    },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.currrent_schedule.name
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    copytoall () {
         if(this.currrent_schedule.dates.Tuesday && this.currrent_schedule.dates.Tuesday.length > 0){
         this.currrent_schedule.dates.Tuesday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
      if(this.currrent_schedule.dates.Wednesday && this.currrent_schedule.dates.Wednesday.length > 0){
         this.currrent_schedule.dates.Wednesday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
       if(this.currrent_schedule.dates.Thursday && this.currrent_schedule.dates.Thursday.length > 0){
         this.currrent_schedule.dates.Thursday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
       if(this.currrent_schedule.dates.Friday && this.currrent_schedule.dates.Friday.length > 0){
         this.currrent_schedule.dates.Friday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
       if(this.currrent_schedule.dates.Saturday && this.currrent_schedule.dates.Saturday.length > 0){
         this.currrent_schedule.dates.Saturday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
       if(this.currrent_schedule.dates.Sunday && this.currrent_schedule.dates.Sunday.length > 0){
         this.currrent_schedule.dates.Sunday.forEach(time => {
            if(time.id){
              this.deletedschedules.push(time.id)
            }
      });
      }
      
      this.currrent_schedule.dates.Tuesday=[]
      this.currrent_schedule.dates.Wednesday=[]
      this.currrent_schedule.dates.Thursday=[]
      this.currrent_schedule.dates.Friday=[]
      this.currrent_schedule.dates.Saturday=[]
      this.currrent_schedule.dates.Sunday=[]
      for (let index = 0; index < this.currrent_schedule.dates.Monday.length; index++) {
        this.currrent_schedule.dates.Tuesday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Wednesday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Thursday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Friday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Saturday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })
        this.currrent_schedule.dates.Sunday.push({
          'start_time': this.currrent_schedule.dates.Monday[index].start_time,
          'end_time': this.currrent_schedule.dates.Monday[index].end_time
        })   
      }
    },
    getTime (day, index, start_time, end_time) {
      const space = '  '
      if (start_time.toString() != '' && end_time.toString() != '') {
        if (end_time > start_time) {
          return ''
        } else {
          return `End Time is Less than Start Time at ${  day   }${space  }${index + 1}`
        }
      }
    },
    StatusSuccess (status) {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Schedule',
        text: `Schedule ${status} Successfully!`,
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail () {
      this.$vs.notify({
        title: 'Schedule',
        text: 'Schedule Failed to Create',
        color: 'danger',
        position: 'top-right'
      })
    },
    StatusRequired () {
      this.$vs.notify({
        title: 'Schedule',
        text: 'Schedule is Required',
        color: 'danger',
        position: 'top-right'
      })
    },
    inputAdd (dayindex) {
      this.currrent_schedule.dates[dayindex].push({
        'start_time': '',
        'end_time': ''
      })
    },
    inputRemove (index, dayindex) {
      if (this.currrent_schedule.dates[index][dayindex].id) {
        this.deletedschedules.push(this.currrent_schedule.dates[index][dayindex].id)
      }
      this.currrent_schedule.dates[index].splice(dayindex, 1)
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.currrent_schedule = {
        'id': '',
        'name': '',
        'dates': {
          Monday: [
            {
              'start_time': '',
              'end_time': ''
            }
          ],
          Tuesday: [
            {
              'start_time': '',
              'end_time': ''

            }
          ],
          Wednesday: [
            {
              'start_time': '',
              'end_time': ''

            }
          ],
          Thursday: [
            {
              'start_time': '',
              'end_time': ''
            }
          ],
          Friday: [
            {
              'start_time': '',
              'end_time': ''
            }
          ],
          Saturday: [
            {
              'start_time': '',
              'end_time': ''
            }
          ],
          Sunday: [
            {
              'start_time': '',
              'end_time': ''
            }
          ]
        }
      },
      this.deletedschedules = []
    },
    submitData () {
      let finalschedule = []
      for (let i = 0; i < this.currrent_schedule.dates.Monday.length; i++) {
        const element = this.currrent_schedule.dates.Monday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Monday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < this.currrent_schedule.dates.Tuesday.length; i++) {
        const element = this.currrent_schedule.dates.Tuesday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Tuesday'
          finalschedule.push(element)
          
        }
      }

      for (let i = 0; i < this.currrent_schedule.dates.Wednesday.length; i++) {
        const element = this.currrent_schedule.dates.Wednesday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Wednesday'
          finalschedule.push(element)
        }
      }

      for (let i = 0; i < this.currrent_schedule.dates.Thursday.length; i++) {
        const element = this.currrent_schedule.dates.Thursday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Thursday'
          finalschedule.push(element)
        }
      }

      for (let i = 0; i < this.currrent_schedule.dates.Friday.length; i++) {
        const element = this.currrent_schedule.dates.Friday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Friday'
          finalschedule.push(element)
        }
      }

      for (let i = 0; i < this.currrent_schedule.dates.Saturday.length; i++) {
        const element = this.currrent_schedule.dates.Saturday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Saturday'
          finalschedule.push(element)
        }
      }

      for (let i = 0; i < this.currrent_schedule.dates.Sunday.length; i++) {
        const element = this.currrent_schedule.dates.Sunday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Sunday'
          finalschedule.push(element)
        }
      }

      let error = 0
       function checkSchedule (finalschedule) {
        if (finalschedule.length > 0) {
          for (let i = 0; i < finalschedule.length; i++) {
            if (finalschedule[i].end_time <= finalschedule[i].start_time) {
              error++
            }
          }
        } else {
          error++
        }
      }
      checkSchedule(finalschedule)
      this.$validator.validateAll().then(result => {
        if (result && error == 0) {
          if (this.currrent_schedule.id !== '' && this.currrent_schedule.id >= 0) {
            const newschedule = []
            for (let i = 0; i < finalschedule.length; i++) {
              if (!finalschedule[i].id) {
                newschedule.push(finalschedule[i])
              }
            }
            finalschedule = finalschedule.filter(function (item) {
              if (item.id) {
                return true
              } else {
                return false
              }
            })
            this.$apollo
              .mutate({
                mutation: UPDATE_SCHEDULE,
                variables: {
                  id:this.currrent_schedule.id,
                  name:this.currrent_schedule.name,
                  status:true,
                  scheduledates: {
                    update:finalschedule,
                    create:newschedule,
                    delete:this.deletedschedules
                  }
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess('updated')
                }
              }).catch(error => {
                this.StatusFail()
                console.log(error)
              })
          }
          if (this.currrent_schedule.id == '') {
            if (finalschedule.length > 0) {
              this.$apollo
                .mutate({
                  mutation: CREATE_SCHEDULE,
                  variables: {
                    name:this.currrent_schedule.name,
                    status:true,
                    scheduledates: {
                      create:finalschedule
                    }
                  }
                })
                .then(response => {
                  if (response) {
                    this.StatusSuccess('Created')

                  }
                }).catch(error => {
                  this.StatusFail()
                })
            }
          }
          this.$emit('closeSidebar')
          this.currrent_schedule.id = ''
          this.deletedschedules = []
          this.initValues()
        }
        else {
          this.StatusRequired()
        }
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.slot-actions{
  clear: both;
  text-align: right;
  margin: 5px;
}
.flatpickr-input{
  width: 50%;
}
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
<style>
.timepicker{
  width: 100%;
}
.vs-tooltip{
  z-index: 99999 ;
}
</style>
